import { useToasterStore } from '@/store/toasterStore'
import { Toast } from './Toast'
import type { ToastProps } from './Toast'

const positions = {
  'top-right': 'top-4 right-4',
  'top-left': 'top-4 left-4',
  'bottom-right': 'bottom-4 right-4',
  'bottom-left': 'bottom-4 left-4'
}

export function Toaster({ position = 'bottom-right' }: { position?: keyof typeof positions }) {
  const toasts = useToasterStore((state) => state.toasts)
  const removeToast = useToasterStore((state) => state.removeToast)

  return (
    <div className={`fixed z-50 ${positions[position]} flex flex-col gap-2`}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast as ToastProps}
          onClose={removeToast}
        />
      ))}
    </div>
  )
}
